module.exports = __webpack_public_path__ + "static/media/loading.04943a7f.gif";